import { observer } from 'mobx-react-lite'
import type { TaxJobDetailsViewModel } from '@/features/jobs/details/tax-type/TaxJobDetailsViewModel'
import { MessagesTabLayout } from '@/features/jobs/details/components/MessagesTabLayout'
import { TaxJobConversationContainer } from '@/features/jobs/details/tax-type/components/TaxJobConversationContainer'

interface TaxJobMessagesTabProps {
  taxVm: TaxJobDetailsViewModel
}

/**
 * Messages tab for tax jobs.
 */
export const TaxJobMessagesTab = observer(function TaxJobMessagesTab({
  taxVm,
}: TaxJobMessagesTabProps) {
  return (
    <MessagesTabLayout>
      <TaxJobConversationContainer
        taxVm={taxVm}
        scrollingElement={document.documentElement}
        composerPositioning="fixed"
      />
    </MessagesTabLayout>
  )
})
